export default __webpack_public_path__ + "static/media/morph_logo_light.ac635831.svg";